import { ConfigProvider } from "antd";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import ReactDOM from "react-dom/client";
// if (localStorage.getItem("isV2") === null) {
//   localStorage.setItem("isV2", "true");
// }
// Configured primary color
// Also support api in future for theming
ConfigProvider.config({
  theme: {
    primaryColor: "rgba(0, 1, 165, 1)",
    successColor: "rgb(217, 224, 33)",
    errorColor: "rgb(238, 125, 17)",
    warningColor: "rgb(176, 206, 236)",
  },
});


if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root") as Element); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <ConfigProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
